import React from 'react';

/**
 * The row actions' icons (Oct 28 2026) — one stroke family at 24 units, drawn in
 * `currentColor` so the ⋯ menu's white (and its red for DELETE) carries through. A menu item
 * names one with `icon: 'wallet'`; an unknown name draws nothing rather than a wrong glyph.
 */
const PATHS = {
  view: <><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z" /><circle cx="12" cy="12" r="3" /></>,
  details: <><path d="M4 6h16M4 12h16M4 18h10" /></>,
  close: <><path d="M6 15l6-6 6 6" /></>,
  verify: <><path d="M12 3l7 3v5c0 4.5-3 8.2-7 10-4-1.8-7-5.5-7-10V6l7-3z" /><path d="M9 12l2 2 4-4" /></>,
  fee: <><path d="M20.6 13.4l-7.2 7.2a2 2 0 01-2.8 0L3 13V3h10l7.6 7.6a2 2 0 010 2.8z" /><circle cx="7.5" cy="7.5" r="1.5" /></>,
  card: <><rect x="3" y="6" width="18" height="12" rx="2" /><path d="M7 10h6M7 14h4" /><circle cx="17" cy="12" r="1.5" /></>,
  flag: <><path d="M5 21V4M5 4h11l-2 4 2 4H5" /></>,
  trash: <><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v6M14 11v6" /></>,
  wallet: <><path d="M3 7a2 2 0 012-2h13v4" /><path d="M3 7v11a2 2 0 002 2h15V9H5a2 2 0 01-2-2z" /><circle cx="16" cy="14.5" r="1.3" /></>,
  transfer: <><path d="M4 8h14l-4-4M20 16H6l4 4" /></>,
  settings: <><path d="M4 6h10M18 6h2M4 12h4M12 12h8M4 18h12M20 18h0" /><circle cx="16" cy="6" r="2" /><circle cx="10" cy="12" r="2" /><circle cx="18" cy="18" r="2" /></>,
  release: <><rect x="4" y="11" width="16" height="10" rx="2" /><path d="M8 11V7a4 4 0 017.7-1.5" /></>,
  person: <><circle cx="12" cy="8" r="4" /><path d="M4 21c1.5-4 4.5-6 8-6s6.5 2 8 6" /></>,
};

export function ActionIcon({ name, size = 16, className = '' }) {
  const d = PATHS[name];
  if (!d) return null;
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className={`flex-shrink-0 ${className}`}>
      {d}
    </svg>
  );
}

export const ACTION_ICONS = Object.keys(PATHS);
